import { Create, TopToolbar } from "react-admin";

import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./Partials/SaveForm";
import { useState } from "react";

const CreateErasmusIncomingTeachers = () => {
  const [cvId, setCVId] = useState(null);
  const [mobilityAgreementId, setMobilityAgreementId] = useState(null);
  const [acceptanceLetterId, setAcceptanceLetterId] = useState(null);

  const dataAll = (obj, keysToRemove = []) => {
    return Object.fromEntries(Object.entries(obj).filter(([key]) => !keysToRemove.includes(key)));
  };

  const handleSend = data => ({
    ...dataAll(data, ["cvId", "mobilityAgreementId", "acceptanceLetterId"]),
    cvId: cvId,
    mobilityAgreementId: mobilityAgreementId,
    acceptanceLetterId: acceptanceLetterId,
  });
  return (
    <Create
      transform={handleSend}
      title="Създай пристигащ преподавател за обучение"
      actions={
        <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
          <BackButtonToolbar />
        </TopToolbar>
      }
    >
      <SaveForm
        setCVId={setCVId}
        setMobilityAgreementId={setMobilityAgreementId}
        setAcceptanceLetterId={setAcceptanceLetterId}
      />
    </Create>
  );
};
export default CreateErasmusIncomingTeachers;
